import styled from '@emotion/styled'

const ArticleAsideNavListItemIcon = styled.div`

`

export default ArticleAsideNavListItemIcon